import { SlashCommand } from './types';

export const steganoCommands: SlashCommand[] = [
    {
        id: 'stegano-embed',
        trigger: '/stegano',
        name: 'SteganoCode Embed/Decode',
        description: 'Embed secret messages/files into images or decode them.',
        category: 'UTILITIES',
        icon: 'fas fa-lock',
        mode: 'prompt',
        integration: 'SteganoCode'
    }
];
